import { Pipe, PipeTransform } from '@angular/core';
import { SfoUiJSONSchema7 } from '../../metadata.model';

@Pipe({ name: 'resolveObjectSchema' })
export class ResolveObjectSchemaPipe implements PipeTransform {
  /**
   * Returns a concrete object schema for rendering nested fields.
   * If `schema` is an object with `properties`, returns it; otherwise resolves the first
   * object variant from `anyOf`/`oneOf`, or falls back to the original schema.
   * @param schema Schema (object or union) to resolve
   * @returns Object schema with `properties` when found; else the original schema
   */
  transform(schema: SfoUiJSONSchema7 | null | undefined): SfoUiJSONSchema7 | null {
    if (!schema) return null;

    if (schema.properties && (schema.type === 'object' || !schema.type)) {
      return schema;
    }

    const candidates = (schema.anyOf || schema.oneOf) as (SfoUiJSONSchema7 | boolean)[] | undefined;
    if (Array.isArray(candidates)) {
      const schemas = candidates.filter(
        (opt): opt is SfoUiJSONSchema7 => typeof opt === 'object' && opt !== null,
      );
      const objectCandidate = schemas.find((opt) => opt.type === 'object' && !!opt.properties);
      if (objectCandidate) return objectCandidate;
    }

    return schema;
  }
}
